import { render, staticRenderFns } from "./Policies.vue?vue&type=template&id=c1811244&scoped=true"
import script from "./Policies.vue?vue&type=script&lang=js"
export * from "./Policies.vue?vue&type=script&lang=js"
import style0 from "./Policies.vue?vue&type=style&index=0&id=c1811244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1811244",
  null
  
)

export default component.exports